
const getEnvironment = () => process.env.NODE_ENV || "development";
const getApiUrl = () => process.env.REACT_APP_API_URL + "/api";

module.exports = {
    getEnvironment,
    getApiUrl
}